// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum EscalatorService {
  Auto = 0,
  MOS = 1,
  Inspection = 2,
  Construction = 3,
  Run = 4,
  Stopped = 5,
  Normal = 6,
  ContinuousOperation = 7,
  DirChangeOperation = 8,
  EngineerOnSite = 9
}
